/**
 * @owner @Appboy/billing
 */

export const webhooksConsumption = "/analytics_dashboard/:app_group_id/webhooks_credit_consumption_detail_data";
